export default __webpack_public_path__ + "cfbe3290818ac418ccf4cf3f40c36927.svg";